import script from "./calc-rule.vue?vue&type=script&setup=true&lang=ts"
export * from "./calc-rule.vue?vue&type=script&setup=true&lang=ts"

import "./calc-rule.vue?vue&type=style&index=0&id=4b71bd39&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b71bd39"]])

export default __exports__